export default __webpack_public_path__ + "static/Frame 774-6d053fad9781e875aac5bf8e003625f6.png";